export enum FieldType {
  Text = 'text',
  Number = 'number',
  LongText = 'long-text',
  Date = 'date',
  Dropdown = 'dropdown',
  Currency = 'currency',
}
